import { lazy, Suspense } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';

const Features = lazy(() => import('./components/Features'));
const About = lazy(() => import('./components/About'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Footer = lazy(() => import('./components/Footer'));
const WhatsAppFloatingButton = lazy(() => import('./components/WhatsAppFloatingButton'));

function App() {
  return (
    <div className="App relative">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<div style={{minHeight:'100vh'}}/>}>
          <Features />
          <About />
          <Testimonials />
          <WhatsAppFloatingButton />
        </Suspense>
      </main>
      <Suspense fallback={<div/>}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
